import declare from "dojo/_base/declare";
import MassReplaceMaterial from "../MaterialSpec/MassReplaceMaterial";

const MassReplaceFoodBOM = declare(MassReplaceMaterial, {
	idBOMFilter: "UsableForStyleBOM",
});

export = MassReplaceFoodBOM;